import { ShareLink } from "components/ShareLink";

interface Props {
  xtmProjectName: string;
  anonymousJobsLink: string;
  onBeforeOpen?: (open: () => void) => void;
  disabled?: boolean;
}

const XtmShareJobLink = ({ anonymousJobsLink, xtmProjectName, onBeforeOpen, disabled }: Props) => {
  return (
    <ShareLink
      url={anonymousJobsLink}
      label={xtmProjectName}
      isLoading={false}
      canCopy={true}
      onBeforeOpen={onBeforeOpen}
      disabled={disabled}
    />
  );
};

export default XtmShareJobLink;
